import { isClient } from '~~/utils'
import useIndexStore from '~~/store/index'
import useSystemStore from '~~/store/system'
import { LANGUAGE } from '~~/enum'
import setLang from '~~/lang/vant/vant-i18n'

export default defineNuxtPlugin((nuxtApp: any) => {
  // 获取默认语言参数
  const query = useRoute()?.query ?? {}
  let lang: string = (query.language as string) || useCookie('language').value || ''
  const langType = {
    en: 'en_US',
    zh: 'zh_CN',
  }
  if (lang in langType) {
    lang = langType[lang]
  }
  console.log('query', query)
  const { SET_LOCALE } = useIndexStore()
  const { SET_LANG } = useSystemStore()
  // 初始化设置语言
  if (lang in LANGUAGE) {
    SET_LOCALE(lang)
    SET_LANG(lang)
    nuxtApp.$i18n.setLocale(lang)
  }

  // 初始化vant语言
  setLang(lang)

  // // 设置字体
  if (isClient()) {
    const rootEle = document.querySelector('html')
    rootEle?.setAttribute('data-lang', lang)
    rootEle?.setAttribute('lang', lang)
  }
})
